const configEnv = {
  strapiApiUrl:
    process.env.REACT_APP_STRAPI_API_URL || "http://localhost:1337/",
};

export default configEnv;